import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HttpClientModule } from '@angular/common/http';


import {RoutingModuleModule} from './routing-module/routing-module.module';
import { IndexComponent } from './index/index.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { LoginComponent } from './login/login.component';
import { FrontpicturesComponent } from './frontpictures/frontpictures.component';
import {FromssComponent} from './fromss/admin.component';
import { AdminComponent } from './admin/admin.component';
import { DummyComponent } from './dummy/dummy.component';
import { ListfacultiesComponent } from './listfaculties/listfaculties.component';
import { WordsontopComponent } from './wordsontop/wordsontop.component';
import { AddfacultiesComponent } from './addfaculties/addfaculties.component';
import { EditfacultyComponent } from './editfaculty/editfaculty.component';
import { ListemployeesComponent } from './listemployees/listemployees.component';
import { AddemployeesComponent } from './addemployees/addemployees.component';
import { EditemployeesComponent } from './editemployees/editemployees.component';
import { AddwrittencontactComponent } from './addwrittencontact/addwrittencontact.component';
import { AddclickablecontactComponent } from './addclickablecontact/addclickablecontact.component';
import { AddnewsComponent } from './addnews/addnews.component';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    PagenotfoundComponent,
    LoginComponent,
    FrontpicturesComponent,
    FromssComponent,
    AdminComponent,
    DummyComponent,
    ListfacultiesComponent,
    WordsontopComponent,
    AddfacultiesComponent,
    EditfacultyComponent,
    ListemployeesComponent,
    AddemployeesComponent,
    EditemployeesComponent,
    AddwrittencontactComponent,
    AddclickablecontactComponent,
    AddnewsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RoutingModuleModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
